export const newsEndpoints = {
    all: () => `/api/news`,
    single: (id: string) => `/api/news/${id}`,
    add: () => `/api/news`,
    update: (id: string) => `/api/news/${id}`,
    delete: (id: string) => `/api/news/${id}`
  };